import React from "react";
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";

const BoardCustomerInfo = () => {
  const { user: currentUser } = useSelector((state) => state.auth);


   let dynText = "";
 
   if(currentUser.roles.includes("ROLE_ADMIN") )
    {
      dynText = "WILLKOMMEN DYN ADMIN";
    }
    else if(currentUser.roles.includes("ROLE_CUSTOMER") )
    {
      dynText = "WILLKOMMEN DYN KUNDE";
    }
    else if(currentUser.roles.includes("ROLE_EMPLOYEE") )
    {
      dynText = "WILLKOMMEN DYN MITARBEITER";
    }
    else if(currentUser.roles.includes("ROLE_MAINVO") )
    {
      dynText = "WILLKOMMEN DYN MAINVO";
    }
    else if(currentUser.roles.includes("ROLE_SUBVO") )
    {
      dynText = "WILLKOMMEN DYN SUBVO";
    }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="container">
      <header className="jumbotron">
        <h3>
          Willkommen {dynText} <strong>{currentUser.username}</strong> 
        </h3>
      </header>
      <p>
        <strong>Token:</strong> {currentUser.accessToken.substring(0, 20)} ...{" "}
        {currentUser.accessToken.substr(currentUser.accessToken.length - 20)}
      </p>
      <p>
        <strong>Id:</strong> {currentUser.id}
      </p>
      <p>
        <strong>E-Mail:</strong> {currentUser.email}
      </p>
      <strong>Berechtigungen:</strong>
      <ul>
        {currentUser.roles &&
          currentUser.roles.map((role, index) => <li key={index}>{role}</li>)}
      </ul>
    </div>
  );
};

export default BoardCustomerInfo;